import route from "@/components/router/Router"

export default {
    path : "company-belong-area",
    name : "company-belong-area",
    meta : {
        title : "所属区划管理",
    },
    redirect : {
        name : "company-belong-area-edit",
    },
    component: route,
    children : [
        {
            path: 'edit',
            name: 'company-belong-area-edit',
            meta: {
                title: '所属区划管理-单位管理'
            },
            component: () => import('@/pages/company/belongArea/Index'),
        },
    ]
}



// WEBPACK FOOTER //
// ./src/router/company/belongArea/index.js